export const parkingAdvantageStyles = {
	header: {
		backgroundColor: '#5F5F60',
	},
	sidebar: {
		backgroundColor: '#050153',
		color: 'white',
	},
	title: {
		color: '#FFFFFF',
	},
	button: {
		backgroundColor: '#050153',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#0083be',
		},
	},
	text: {
		color: '#000000ff',
		buttonLoadingColor: '#FFFFFF',
	},
	table: {
		headerBackgroundColor: '#050153',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Parking Advantage',
	},
	logo: {
		small: {
			src: '/parkingAdvantage/parkingAdvantageSmall.png',
			height: 35,
			width: 35,
		},
		large: {
			src: '/parkingAdvantage/parkingAdvantageBig.webp',
			height: 56,
			width: 150,
		},
	},
	favicon: {
		src: '/parkingAdvantage/parkingAdvantageSmall.png',
	},
	socials: {},
	siteUrl: 'https://www.parkingadvantage.com',
	orgName: 'Parking Advantage',
};
